import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialSchoolState = {
    name: null,
    location: null,
    head_office: false,
    school_id: null,
    tax_percentage: null,
    currency: null,
    debit_account_id: null,
    credit_account_id: null,
    trn_no: null,
    academic_year_id: null
};

export const SchoolSchema = Yup.object().shape({
    name: Yup.string().required(),
    location: Yup.string().required(),
    head_office: Yup.boolean().required(),
    school_id: Yup.string().required(),
    tax_percentage: Yup.number().min(0).max(100).nullable(),
    currency: Yup.string().nullable(),
    debit_account_id: Yup.number().required(),
    credit_account_id: Yup.number().required(),
    trn_no: Yup.string().nullable(),
    academic_year_id: Yup.number().required()
});

export const FormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "location", title: "Location", required: true, type: VALUE_TYPES.TEXT },
    { name: "school_id", title: "School ID", required: true, type: VALUE_TYPES.TEXT },
    { name: "tax_percentage", title: "Tax %", required: false, type: VALUE_TYPES.DECIAML },
    { name: "currency", title: "Currency", required: false, type: VALUE_TYPES.TEXT },
    { name: "trn_no", title: "TRN NO", required: false, type: VALUE_TYPES.TEXT },
    { name: "debit_account_id", title: "Debit Account", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "credit_account_id", title: "Credit Account", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
    { name: "head_office", title: "Head Office", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Yes", id: true }, { title: "No", id: false }] },
];

const filterState = {
    schools: null,
    location: null,
    currency: null,
};

const filterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    location: Yup.string().nullable(),
    currency: Yup.string().nullable(),

});

const filterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "location", title: "Location", required: false, type: VALUE_TYPES.TEXT },
    { name: "currency", title: "Currency", required: false, type: VALUE_TYPES.TEXT },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}
